/* eslint-env browser */
import React from 'react';
import PropTypes from 'prop-types';
import DropdownComponent from './DropdownComponent';

class SearchComponent extends React.Component {
  constructor(props) {
    super(props);

    this.state = { query: '', associations: [0, 0, 0] };
    this.handleKeyUp = this.handleKeyUp.bind(this);
    this.search = this.search.bind(this);
    this.dropDownSearch = this.dropDownSearch.bind(this);
  }

  handleKeyUp(e) {
    const { associations } = this.state;
    const query = e.target.value.trim().toLowerCase();
    this.search(query, associations);
    this.setState({ query });
  }

  search(query, associations) {
    const {
      queryLength,
      getEducations,
      setEducations,
      educations: pEducations,
      emptyEvuLoad,
    } = this.props;
    const assocsSelected = () => {
      for (let i = 0; i < associations.length; i += 1) {
        if (associations[i] !== 0) {
          return true;
        }
      }

      return false;
    };

    if (query.length >= queryLength || query.length === 0) {
      const lEducations = getEducations(query, associations);
      if (lEducations.length === 0 && query.length === 0 && !assocsSelected()) {
        setEducations(pEducations);
      } else if (emptyEvuLoad && lEducations.length === pEducations.length
        && query.length === 0 && !assocsSelected()) {
        setEducations([]);
      } else {
        setEducations(lEducations);
      }
    }
  }

  dropDownSearch(assoc, index) {
    const { associations, query } = this.state;
    associations[index] = assoc;
    this.search(query, associations);
    this.setState({ associations });
  }

  render() {
    const { groupings, educationCount } = this.props;
    const { query, associations } = this.state;
    const ddNodes = groupings.map((group, i) => {
      if (i < 3) { // Type, emne, sted
        return (
          // eslint-disable-next-line react/no-array-index-key
          <div key={i} className="column large-4 medium-4 small-12">
            <div>
              <DropdownComponent index={i} grouping={group} dropDownSearch={this.dropDownSearch} />
            </div>
          </div>
        );
      }
      return null;
    });

    return (
      <div className="row">
        <div className="column large-12 medium-12 small-12">
          <div className="evu-search">
            <input type="text" placeholder="Indtast dit søgeord..." onKeyUp={this.handleKeyUp} />
          </div>
        </div>
        <div className="column large-12 medium-12 small-12">
          <div className="evu-filter">
            <div className="row">
              {(() => {
                // eslint-disable-next-line no-mixed-operators
                if (query !== '' || (associations[0] > 0 || associations[1] > 0 || associations[2] > 0) && query === '') {
                  return (
                    <div className="column large-12 medium-12 small-12">
                      <p className="result-count">
                        <strong>
                          {`${educationCount} aktiviteter fundet`}
                        </strong>
                      </p>
                    </div>
                  );
                }
                return null;
              })()}
            </div>
            <div className="row">
              {ddNodes}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

SearchComponent.propTypes = {
  educationCount: PropTypes.number.isRequired,
  educations: PropTypes.arrayOf(PropTypes.shape({}).isRequired).isRequired,
  getEducations: PropTypes.func.isRequired,
  groupings: PropTypes.arrayOf(PropTypes.shape({}).isRequired).isRequired,
  queryLength: PropTypes.number,
  setEducations: PropTypes.func.isRequired,
  emptyEvuLoad: PropTypes.bool.isRequired,
};

SearchComponent.displayName = 'SearchComponent';

// Uncomment properties you need
// SearchComponent.propTypes = {};
SearchComponent.defaultProps = {
  queryLength: 2,
};

export default SearchComponent;
